// extracted by mini-css-extract-plugin
module.exports = {"login-form":"InicioSesion_login-form__3ltAj","login-form-forgot":"InicioSesion_login-form-forgot__1wzHA","login-form-button":"InicioSesion_login-form-button__2oSEz"};